import { Card } from '@chakra-ui/react'
import { PropsWithChildren } from 'react'

interface Props {
    title?: string
}

export const CardComponent = (props: PropsWithChildren<Props>) => {
    return (
        <Card.Root variant={'elevated'} minW="0">
            <Card.Body gap="2">
                <Card.Title mb="2">{props.title}</Card.Title>
                {props.children}
            </Card.Body>
            <Card.Footer justifyContent="flex-end"></Card.Footer>
        </Card.Root>
    )
}
